module.exports = __webpack_public_path__ + "static/img/t1.270d4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t1.png
// module id = DaXA
// module chunks = 1